module.exports = __webpack_public_path__ + "static/img/4.e7e8e39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/4.png
// module id = foVS
// module chunks = 0